import { computed, inject, Injectable } from '@angular/core';
import { AnamnesisObject } from '@libs/types/src/services/object-type/anamnesis/anamnesis.object';
import { localDate } from '../../../../shared/pipes/local-date.pipe';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { SessionService } from '../../../../../services/session.service';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';

@Injectable()
export class MedicalReportCreateStore extends ComponentStoreV2Factory {

    public readonly session = inject(SessionService);
    protected readonly folderStore = inject(FolderGlobalStore);

    public folderId = this.folderStore.folderId();

    public anamneses = computed(() => {
        return this.data.getAnamneses()?.items.map((item: AnamnesisObject, index: number) => {
            return {
                ...item,
                data: item.anamnesis,
                createdAt: localDate(item.updatedAt, this.session),
                index,
            };
        });
    });
}
